//#region redux
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { setShowAllCompaniesTodoOverview } from "store/actions/authActions";
//#endregion
import useSettingsService from "./useSettingsService";

/**
 * The person's Heart setting for the "Samtliga bolag" overview, kept in auth state so the company
 * selector and the page read it without fetching. Undefined until loaded; a failed load counts as off.
 */
function useAllCompaniesTodoSetting() {
  const dispatch = useDispatch();
  const settingsService = useSettingsService();

  const showOverview = useSelector((store: AppState) => store.auth.showAllCompaniesTodoOverview);

  const load = () =>
    settingsService
      .getProfileSettingsSilent()
      .then((settings) => dispatch(setShowAllCompaniesTodoOverview(settings.showAllCompaniesTodoOverview === true)))
      .catch(() => dispatch(setShowAllCompaniesTodoOverview(false)));

  return { showOverview, load };
}

export default useAllCompaniesTodoSetting;
